import {Container, Row, Col } from 'react-bootstrap';
import Card from './Cards';
import skillsFrontend from '../data/skillsFrontend';
import skillsBackend from '../data/skillsBackend';
import skillsFullstack from '../data/skillsFullstack';
import planning from '../data/planning';
import imageProcessing from '../data/imageProcessing';
import roboticsSkills from '../data/roboticsSkills';
import TypeAnimation from 'react-type-animation';

export default function Skills() {
	console.log(skillsFrontend);
	console.log(skillsBackend);

	const allFrontend = skillsFrontend.map(skill => {
        return (
        	<Col xs={12} md={4}>
            	<Card key={skill.id} skills={skill}/>
            </Col>
        );
	}); 

	const allBackend = skillsBackend.map(skill => {
        return (
        	<Col xs={12} md={4}>
            	<Card key={skill.id} skills={skill}/>
            </Col>
        );
	});


	const allFullstack = skillsFullstack.map(skill => {
        return (
        	<Col xs={12} md={4}>
            	<Card key={skill.id} skills={skill}/>
            </Col>
        );
	});

	const allPlanning = planning.map(plan => {
        return (
        	<Col xs={12} md={4}>
            	<Card key={plan.id} skills={plan}/>
            </Col>
        );
	});

	const allProcessing = imageProcessing.map(image => {
        return (
        	<Col xs={12} md={4}>
            	<Card key={image.id} skills={image}/>
            </Col>
        );
	});

	const allRobotics = roboticsSkills.map(robot => {
        return (
        	<Col xs={12} md={4}>
            	<Card key={robot.id} skills={robot}/>
            </Col>
        );
	});

	return(
		<Container id="skills" className="mb-4">
		<TypeAnimation
		  cursor={false}
		  sequence={[ 
		     'Skills', 1000, 
		     'technologies', 1000, 
		     'familiar platforms', 1000, 
		     'Skills', 1000]}
		  wrapper="p"
		  className="about-me-label text-center mt-4"
		  />
		   	<h3 className="skillSet">Planning and Process</h3>
	   		<Row>
	   	   		{allPlanning}
	   	   	</Row>
			<h3 className="skillSet">FrontEnd Technologies</h3>	 
			<Row>
		   		{allFrontend}
		   	</Row>
		   	<h3 className="skillSet">BackEnd Technologies</h3>	
		   	<Row>
		   		{allBackend}
		   	</Row>
		   	<h3 className="skillSet">FullStack Technologies</h3>
		   	<Row>
		   		{allFullstack}
		   	</Row>	
		   	<h3 className="skillSet">Robotics Platforms</h3>
		   	<Row>
		   		{allRobotics}
		   	</Row>	
		   	<h3 className="skillSet">Image Processing Platforms</h3>
		    <Row>
		    	{allProcessing}
		    </Row>	
	    </Container>
	);
};